import { defineStore } from 'pinia'

/**
 * Pinia store tracking the admin's current Acting / Impersonation session (#623).
 *
 * Hydrated by `useActing.refreshStatus()` which calls GET /api/v1/admin/acting.
 * Cleared by `stopActing()` or when the session TTL expires.
 *
 * NOT persisted across reloads — the source of truth is DynamoDB on the
 * backend, so we always re-fetch on app mount.
 */
export const useActingStore = defineStore('_cam_acting', () => {
  const sessionId = ref<string | null>(null)
  const subjectUserId = ref<string | null>(null)
  const subjectName = ref<string | null>(null)
  const reason = ref<string | null>(null)
  const startedAt = ref<number | null>(null)
  const expiresAt = ref<number | null>(null)

  const isActing = computed(() => sessionId.value !== null)

  const setSession = (payload: {
    sessionId: string
    subjectUserId: string
    subjectName: string | null
    reason: string
    startedAt: number
    expiresAt: number
  }) => {
    sessionId.value = payload.sessionId
    subjectUserId.value = payload.subjectUserId
    subjectName.value = payload.subjectName
    reason.value = payload.reason
    startedAt.value = payload.startedAt
    expiresAt.value = payload.expiresAt
  }

  const clear = () => {
    sessionId.value = null
    subjectUserId.value = null
    subjectName.value = null
    reason.value = null
    startedAt.value = null
    expiresAt.value = null
  }

  return {
    // state
    sessionId,
    subjectUserId,
    subjectName,
    reason,
    startedAt,
    expiresAt,
    // getters
    isActing,
    // actions
    setSession,
    clear,
  }
})
